import { Modal } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { useAppStore } from '../../../store/store';

/**
 * Non-closable overlay shown when the backend returns HTTP 429 (Too Many Requests).
 * Visibility is driven by `appEvents.tooManyRequests.lockedUntil`, which is persisted in
 * localStorage so the overlay survives page reloads until the wall-clock window elapses.
 * The 1s tick is re-armed on rehydration via `restoreFromPersistence` (see store wiring).
 */
export default function TooManyRequestsOverlay() {
  const { t } = useTranslation();

  // Drive visibility from the persisted epoch so a hard refresh keeps the overlay open
  // until the original 15s window has elapsed.
  const isOpen = useAppStore((s) => {
    const lockedUntil = s.appEvents.tooManyRequests.lockedUntil;
    return lockedUntil != null && lockedUntil > Date.now();
  });
  const secondsLeft = useAppStore((s) => s.appEvents.tooManyRequests.secondsLeft);

  const modalStyles = { mask: { backdropFilter: 'blur(5px)' } };

  return (
    <Modal
      open={isOpen}
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      footer={null}
      centered
      width={400}
      zIndex={9999}
      data-testid="too-many-requests-modal"
      styles={modalStyles}
      className="bg-black/25! backdrop-blur-sm!"
    >
      <h2 className="text-red-dark mb-2 text-lg font-semibold">
        {t('modal.tooManyRequestsOverlay.title')}
      </h2>
      <p className="text-blue-dark mb-2 text-sm">{t('modal.tooManyRequestsOverlay.description')}</p>
      <p className="text-blue-dark text-sm">
        <Trans>{t('modal.tooManyRequestsOverlay.redirectMessage', { seconds: secondsLeft })}</Trans>
      </p>
    </Modal>
  );
}
